// extracted by mini-css-extract-plugin
export default {"container":"CopyButton_container__pQBSa","tip":"CopyButton_tip__BiLK5","active":"CopyButton_active__Z79m0"};